@use '@/styles/tokens' as *;

// Figma 1790:978386: avatar, then the field rows, 20px apart.
.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

// Figma 1790:978389 / 978392: two 300px columns 13px apart (12 is the nearest token); rows 20px
// apart. <FormField>'s own stacking margin is dropped so the grid's gap alone sets the rhythm.
.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-5) var(--space-3);

  @include up(sm) {
    grid-template-columns: 1fr 1fr;
  }

  > div {
    margin-bottom: 0;
  }
}

.changePhone {
  @include reset-button;

  display: inline-flex;
  color: var(--text-muted);
  border-radius: var(--radius-pill);

  &:disabled {
    cursor: not-allowed;
  }
}
